import { FieldTitle } from '../common/index';
import DefaultValue from './defaultValue';
import React from 'react';

function CheckBox(props) {
  const { label, internalTitle, formId, required, className, options } = props;
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
  const asterisk = required ? ' *' : null;
  const diamondSpans = "<span class='diamond-outer'><span class='diamond-inner'></span></span>";
  const rawLabel = `${diamondSpans}${label}${asterisk}`;
  const processedLabel =
    options && {}.hasOwnProperty.call(options, 'render_raw_label') ? (
      <label
        htmlFor={forId}
        dangerouslySetInnerHTML={{ __html: rawLabel }}
      />
    ) : (
      <label htmlFor={forId}>
        <span className="diamond-outer">
          <span className="diamond-inner" />
        </span>
        {label}
        {asterisk}
      </label>
    );

  return (
    <div className={`${className} input checkbox`}>
      <input
        type="checkbox"
        name={internalTitle}
        id={forId}
        required={required}
        defaultChecked={DefaultValue.checkAutomatically(options)}
      />
      {processedLabel}
    </div>
  );
}

CheckBox.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  className: React.PropTypes.string,
  options: React.PropTypes.object
};

CheckBox.defaultProps = {
  className: 'formgroup'
};

export default CheckBox;



// WEBPACK FOOTER //
// ./components/forms/checkBox.js